import classNames from "classnames";
import useReadableText from "../../hooks/useReadableText";

interface Props {
  query: any;
  moduleAPIName: string | undefined;
  fallbackMessage?: string;
  onClick?: () => void;
  maxWidth?: number | string;
  disabled?: boolean;
}

const ReadableFilter = ({
  query,
  moduleAPIName,
  fallbackMessage = "No Filters Have Been Added.",
  onClick,
  maxWidth = 500,
  disabled,
}: Props) => {
  const { readableText } = useReadableText({
    query,
    moduleAPIName,
    fallbackMessage,
  });

  let replacement = null;

  if (!query || !query?.Filters) replacement = fallbackMessage;

  return (
    <div
      className={classNames("d-flex border px-2 rounded-sm", {
        "cursor-pointer bg-white": !disabled,
        "bg-lighter cursor-not-allowed": disabled,
      })}
      style={{ maxWidth: maxWidth, paddingTop: 4.25, paddingBottom: 4.25 }}
      onClick={onClick ? (disabled ? undefined : onClick) : undefined}
    >
      <div style={{ wordWrap: "break-word" }} className="w-100 text-sm">
        {replacement ? replacement : readableText}
      </div>
    </div>
  );
};

export default ReadableFilter;
